import React from 'react';
import {BooleanInputProps} from '../shared/props';
import scss from './RsnSwitch.module.scss';

const RsnSwitch = ({className = '', inputRef, ...props}: BooleanInputProps) => (
    <input {...props} ref={inputRef} type='checkbox' className={`${className} ${scss.input}`} />
);
RsnSwitch.displayName = 'RsnSwitch';

export default RsnSwitch;
